import { render } from "./PersonaFisica.vue?vue&type=template&id=efcf5b90"
import script from "./PersonaFisica.vue?vue&type=script&lang=js"
export * from "./PersonaFisica.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__